import { useSelector } from 'react-redux';
import _ from 'lodash';
import metricsStore from '@src/globalStore/metricsStore';
import { activeDashboardSelector } from '@src/store/tempDashboard/selectors';
import {
  isAppSPIEnabledSelector,
  isEcoAudienceEngagementEnabledSelector,
} from '@src/store/common/selectors';
import { getValidPresetKeys } from '@src/utils/presets/utils';
import { isAppModule } from '@src/utils/constants';

const useGlobalExcludeMetricCategories = (defaultExcludeCategories?: string[]) => {
  const { usecaseKey }: any = useSelector(activeDashboardSelector);
  const presetKeys = getValidPresetKeys();
  const { metricsCategoryKeys } = metricsStore.getState();
  const isEcoAudienceEngagementEnabled = useSelector(isEcoAudienceEngagementEnabledSelector);
  const isAppSPIEnabled = useSelector(isAppSPIEnabledSelector);
  const isECOContext = isAppModule;
  const currentExcludeCategories = defaultExcludeCategories ?? [];
  if (isECOContext) {
    currentExcludeCategories.push(metricsCategoryKeys.ECO_ENGAGEMENT);
  }
  if (isECOContext && isEcoAudienceEngagementEnabled && usecaseKey === presetKeys.ECO_ENGAGEMENT) {
    _.pull(currentExcludeCategories, metricsCategoryKeys.ECO_ENGAGEMENT);
  }
  if (isECOContext && !isAppSPIEnabled) {
    currentExcludeCategories.push(metricsCategoryKeys.ECO_QOE);
  }
  return currentExcludeCategories;
};

export default useGlobalExcludeMetricCategories;
